
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'DR',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Endocrine/DR.vue